import { isValidElement, type ReactElement } from 'react';
import { matchRoutes } from 'react-router-dom';

import AuthGuard from '@features/auth/guards/AuthGuard';

import { getRegisteredRoutes } from '@router/routeRegistry';

function findAuthGuardElement(pathname: string): ReactElement | null {
  const matches = matchRoutes(getRegisteredRoutes(), pathname);
  if (!matches) return null;

  for (const match of matches) {
    const element = match.route.element;
    if (isValidElement(element) && element.type === AuthGuard) {
      return element;
    }
  }
  return null;
}

export function isAuthGuardedPath(pathname: string): boolean {
  return findAuthGuardElement(pathname) !== null;
}

export function getAuthGuardAllowGuest(pathname: string): boolean {
  const element = findAuthGuardElement(pathname);
  if (!element) return false;
  const props = element.props as { allowGuest?: boolean };
  return Boolean(props.allowGuest);
}
